// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.store/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.arrbox[data-v-c71ff98a] {\n  background-color: white;\n  font-size: 12px;\n  border-radius: 6px;\n  margin-bottom: 0px;\n  text-align: left;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 460px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
